import api from "./api";

export const criarAberturaIncidentes = async (params) =>
  api.post("/api/sac/incidente/criar", params);

  export const buscarOcorrencias = async (params) =>
  api.post("/api/sac/config/buscar", params);

  export const pesquisaDoc = async (params) =>
  api.post("/api/sac/pesquisadoc", params);

  export const pesquisaBase = async (params) =>
  api.post("/api/sac/pesquisabase", params);


